import styled from "styled-components";

const DemoteMemberContainer = styled.div`

`;

export default DemoteMemberContainer;